<p-toast></p-toast>

<div class="grid">
    <div class="col-12">
        <div class="card">
            <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-3 mb-4">
                <div>
                    <h5 class="m-0">Inbox WhatsApp</h5>
                    <small class="text-600">Seguimiento operativo de conversaciones entrantes y respuestas manuales.</small>
                </div>
                <button pButton type="button" icon="pi pi-refresh" label="Actualizar" class="p-button-outlined" (click)="applyFilters()"></button>
            </div>

            <form [formGroup]="filterForm" class="grid inbox-filter mb-3">
                <ng-container *ngIf="isSuperUser">
                    <div class="col-12 md:col-3">
                        <p-autoComplete
                            formControlName="empresa_lookup"
                            [suggestions]="empresaSuggestions"
                            field="nombre"
                            placeholder="Empresa"
                            styleClass="w-full"
                            [inputStyle]="{ width: '100%' }"
                            [dropdown]="true"
                            [forceSelection]="true"
                            (completeMethod)="searchEmpresas($event)"
                            (onSelect)="onEmpresaSelect($event)"
                            (keydown.enter)="applyFilters()">
                            <ng-template let-empresa pTemplate="item">
                                <div class="flex flex-column">
                                    <span class="font-semibold">{{ empresa.nombre }}</span>
                                    <small class="text-600">ID {{ empresa.id }}</small>
                                </div>
                            </ng-template>
                        </p-autoComplete>
                    </div>
                </ng-container>
                <div class="col-12" [ngClass]="isSuperUser ? 'md:col-3' : 'md:col-4'">
                    <span class="p-input-icon-left w-full">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" class="w-full" formControlName="search" placeholder="Buscar por teléfono, nombre o asignado" (keydown.enter)="applyFilters()" />
                    </span>
                </div>
                <div class="col-12" [ngClass]="isSuperUser ? 'md:col-2' : 'md:col-2'">
                    <p-inputNumber
                        inputId="conversation_id"
                        formControlName="conversation_id"
                        placeholder="ID conversación"
                        styleClass="w-full"
                        inputStyleClass="w-full"
                        mode="decimal"
                        [useGrouping]="false"
                        [min]="1"
                        [minFractionDigits]="0"
                        [maxFractionDigits]="0"
                        (keydown.enter)="applyFilters()"></p-inputNumber>
                </div>
                <div class="col-12" [ngClass]="isSuperUser ? 'md:col-2' : 'md:col-3'">
                    <p-calendar formControlName="conversation_start_from" dateFormat="dd/mm/yy" placeholder="Desde" styleClass="w-full" [inputStyle]="{ width: '100%' }" appendTo="body"></p-calendar>
                </div>
                <div class="col-12" [ngClass]="isSuperUser ? 'md:col-2' : 'md:col-3'">
                    <p-calendar formControlName="conversation_start_to" dateFormat="dd/mm/yy" placeholder="Hasta" styleClass="w-full" [inputStyle]="{ width: '100%' }" appendTo="body"></p-calendar>
                </div>
                <div class="col-12" [ngClass]="isSuperUser ? 'md:col-3' : 'md:col-4'">
                    <p-dropdown [options]="statusOptions" formControlName="ui_status" optionLabel="nombre" optionValue="valor" placeholder="Estado" styleClass="w-full"></p-dropdown>
                </div>
                <div class="col-12" [ngClass]="isSuperUser ? 'md:col-3' : 'md:col-4'">
                    <div class="flex flex-column md:flex-row gap-3 h-full">
                        <div class="field-checkbox m-0">
                            <p-checkbox inputId="onlyUnread" [binary]="true" formControlName="only_unread"></p-checkbox>
                            <label for="onlyUnread">Solo no leídas</label>
                        </div>
                        <div class="field-checkbox m-0">
                            <p-checkbox inputId="onlyUnassigned" [binary]="true" formControlName="only_unassigned"></p-checkbox>
                            <label for="onlyUnassigned">Solo sin asignar</label>
                        </div>
                    </div>
                </div>
            </form>

            <div class="flex gap-2 justify-content-end mb-3">
                <button pButton type="button" label="Limpiar" icon="pi pi-filter-slash" class="p-button-text" (click)="clearFilters()"></button>
                <button pButton type="button" label="Aplicar" icon="pi pi-filter" (click)="applyFilters()"></button>
            </div>

            <p-table
                [value]="conversations"
                [lazy]="true"
                [paginator]="true"
                [rows]="size"
                [totalRecords]="totalRecords"
                [rowsPerPageOptions]="rowsPerPageOptions"
                responsiveLayout="scroll"
                styleClass="p-datatable-sm p-datatable-gridlines"
                [loading]="loading"
                currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} conversaciones"
                [showCurrentPageReport]="true"
                (onLazyLoad)="loadConversations($event)">

                <ng-template pTemplate="header">
                    <tr>
                        <th *ngIf="isSuperUser">Empresa</th>
                        <th>ID</th>
                        <th>Inicio conversación</th>
                        <th>Cliente</th>
                        <th>Último mensaje</th>
                        <th>Estado</th>
                        <th>Asignado</th>
                        <th>No leídas</th>
                        <th>Última actividad</th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-conversation>
                    <tr class="conversation-row" (click)="openConversation(conversation)">
                        <td *ngIf="isSuperUser">
                            <div class="font-semibold">{{ conversation.nombre_empresa || ('Empresa ' + conversation.id_empresa) }}</div>
                            <small class="text-600">ID {{ conversation.id_empresa }}</small>
                        </td>
                        <td>
                            <span class="font-semibold">{{ conversation.id }}</span>
                        </td>
                        <td>
                            <span *ngIf="conversation.conversation_started_at || conversation.first_inbound_at; else noConversationStart">
                                {{ (conversation.conversation_started_at || conversation.first_inbound_at) | date: 'dd/MM/yyyy HH:mm' }}
                            </span>
                            <ng-template #noConversationStart>
                                <span class="text-500">—</span>
                            </ng-template>
                        </td>
                        <td>
                            <div class="font-semibold">{{ conversation.contact_name || conversation.nombre || conversation.customer_phone }}</div>
                            <small class="text-600">{{ conversation.customer_phone_normalized || conversation.customer_phone }}</small>
                            <div *ngIf="conversation.historial_nombre" class="text-500 text-sm mt-1">{{ conversation.historial_nombre }}</div>
                        </td>
                        <td>
                            <div class="flex align-items-center gap-2 mb-1">
                                <i [class]="getDirectionIcon(conversation.last_message_direction_code) + ' text-600'"></i>
                                <small class="text-600">{{ getDirectionLabel(conversation.last_message_direction_code) }}</small>
                            </div>
                            <div class="message-preview">{{ conversation.last_message_preview || 'Sin preview disponible' }}</div>
                        </td>
                        <td>
                            <div class="flex flex-column gap-2 align-items-start">
                                <span
                                    [pTooltip]="getStatusDetail(conversation)"
                                    [tooltipDisabled]="!getStatusDetail(conversation)"
                                    tooltipPosition="top">
                                    <p-tag [severity]="getStatusSeverity(conversation)" [value]="getStatusLabel(conversation)"></p-tag>
                                </span>
                                <span
                                    *ngIf="showWindowClosedHint(conversation)"
                                    pTooltip="La ventana de 24 horas para responder libremente ya cerró. Si esta conversación tenía un flujo automático en curso, quedó pausado acá."
                                    tooltipPosition="top">
                                    <p-tag severity="warning" value="Ventana cerrada" icon="pi pi-clock"></p-tag>
                                </span>
                            </div>
                        </td>
                        <td>
                            <span *ngIf="conversation.assigned_user_name; else unassigned">{{ conversation.assigned_user_name }}</span>
                            <ng-template #unassigned>
                                <span class="text-500">Sin asignar</span>
                            </ng-template>
                        </td>
                        <td>
                            <p-badge [value]="conversation.unread_count || 0" [severity]="(conversation.unread_count || 0) > 0 ? 'danger' : 'info'"></p-badge>
                        </td>
                        <td>
                            <div>{{ conversation.last_message_at | date: 'dd/MM/yyyy HH:mm' }}</div>
                        </td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="isSuperUser ? 9 : 8">
                            <div class="py-5 text-center text-600">
                                No se encontraron conversaciones con los filtros actuales.
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
